/**
 * Pre-warms the in-memory + localStorage cache for all Master Data tabs.
 *
 * Call this as soon as the MasterData page mounts (before the user has a chance
 * to click any tab).  By the time they click Materials or Accessories the API
 * response is already resolved and the tab appears instantly.
 *
 * All calls are fire-and-forget — failures are silently swallowed so a slow
 * network never breaks the page render.
 */
import { prefetch } from './apiCache';
import * as departmentApi     from '../api/departmentApi';
import * as materialGroupApi  from '../api/materialGroupApi';
import * as accessoryGroupApi from '../api/accessoryGroupApi';
import * as makesApi          from '../api/makeApi';

// Materials/Accessories are no longer prefetched here — both tabs now query
// a live, paginated/filtered endpoint per page instead of caching the full
// table (see MaterialsTab.jsx / AccessoriesTab.jsx), so there's no
// 'materials:all' / 'accessories:all' cache entry left for this to warm.
export function prefetchMasterData() {
  prefetch('departments:all',     () => departmentApi.getAll());
  prefetch('materialGroups:all',  () => materialGroupApi.getAll());
  prefetch('accessoryGroups:all', () => accessoryGroupApi.getAll());
  prefetch('makes:all',           () => makesApi.getAll());
}
